<template>
  <div class="row match-header flex-center-vertical">
    <p class="match-display-id text-center">
      {{ idDisplay }}
    </p>
    <i
      class="n-i match-header-icon"
      :class="`n-i-live-${sport.id}`"
    />
    <span :class="`sport-name sport-name-${idSport} font-italic font-bold text-upper`">
      {{ sport.nameShort }}
    </span>
    <span :class="`tournament-name tournament-name-${idSport}`">{{ tournamentName }}</span>
    <span class="filler" />
    <span class="period-time font-italic font-bold color-important">
      {{ periodTime }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'MatchHeader',
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
  },
  computed: {
    sport() {
      return this.$store.getters.getSport(this.idMatch);
    },
    idDisplay() {
      return this.$store.getters.getMatchIdDisplay(this.idMatch);
    },
    matchStatus() {
      return this.$store.getters.getMatchStatus(this.idMatch);
    },
    periodTime() {
      const sport = this.$store.getters.getSport(this.idMatch);
      const matchStatus = this.$store.getters.getMatchStatus(this.idMatch);

      if (sport.id === 21 && matchStatus.overs) {
        return `${this.matchStatus.overs}o`;
      }

      return this.matchStatus.periodTime;
    },
    idTournament() {
      return this.$store.getters.getTournamentId(this.idMatch);
    },
    tournamentName() {
      return this.$store.getters.getTournamentName(this.idTournament);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

$header-linear-colors: (
  1: (#12632c, #192622), // soccer
  2: (#255d90, #1b252d), // basketball
  3: (#596364, #222628), // baseball
  4: (#0e3b58, #192227), //ice-hokey
  5: (#7d421a, #24221f), // tennis
  6: (#1a6168, #1a2628), // handbal
  12: (#1f705c, #1b2827), // rugby
  13: (#743233, #252122), // aussie-rules
  16: (#3a2c29, #1e2021), // american-football
  19: (#772a3f, #251f24), // snooker
  20: (#0a4e46, #182424), // table-tennis
  21: (#0c4c71, #18232a), // cricket
  22: (#8b2d2e, #241f21), // darts
  23: (#523a19, #21211f), // valleyball
  29: (#294d1e, #1c2320), // futsal
  31: (#09584f, #182526), // badminton
  32: (#342e2d, #1c1f21), // bowling
  34: (#775125, #252421), // beach-volley
  37: (#6a5a7c, #212328), // squash
  109: (#566575, #21272a), // counter-strike
  110: (#73701d, #252820), // league-of-legends
  111: (#8f400c, #28221e), // dota
);

.match-header {
  padding-right: 20px;
  color: $color-text-primary;
  background-color: $sport-header-color-back;
}

.match-display-id {
  float: left;
  width: $match-display-id-width;
  height: 100%;
  padding-left: $match-vertical-line-width;
  background-color: $match-id-color-back;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-weight: $font-weight-bold;
  font-size: 0.875rem;
}

.match-header-icon {
  line-height: 1;
  padding-left: 10px;
  font-size: 0.75rem;
}

.sport-name {
  line-height: 1;
  padding-left: 10px;
  padding-right: 5px;
  font-size: 1rem;
  flex: 0 0 25%;
  white-space: nowrap;
  overflow: hidden;
  position:relative;

  &:before {
    content:'';
    width: 70%;
    height: 100%;
    position:absolute;
    left: 50%;
    top:0;
    bottom: 0;
  }

  @each $property, $value in $header-linear-colors {
    &-#{$property}:before {
      background: linear-gradient(to left, nth($value, 1), transparent);
    }
  }
}

.period-time {
  height: 100%;
  font-size: 0.9rem;
}

.tournament-name {
  font-size: 0.83rem;
  margin-left: 0.666em;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  flex-basis: 60%;
  font-weight: 400;
  position: relative;

  &:before {
    content:'';
    width: 50%;
    height:100%;
    position:absolute;
    left: 60%;
    top:0;
    bottom: 0;
  }

  @each $property, $value in $header-linear-colors {
    &-#{$property}:before {
      background: linear-gradient(to left, nth($value, 2), transparent);
    }
  }
}
</style>
